import {Requestor} from 'hegyd/core/resources/assets/js/utils/Requestor.js'

export default class RemovePromotionBtn extends HTMLAnchorElement {
    constructor() {
        super();

        this.mainContainer = document.getElementById('main-container');
    }

    connectedCallback() {
        this.initEvents();
    }

    getSelectorRemoveCodePromo() {
        return '#remove-promo, #remove-promo i';
    }

    getElementRemoveCodePromo(container) {
        return container.querySelector(this.getSelectorRemoveCodePromo());
    }

    removeCodePromo(container,item) {
        var requestor = new Requestor();

        requestor.sendRequest( item.href, 'DELETE', {
            return_templates: ['cart-prices', 'cart-promotion-apply']
        }, (data) => {
            toastr.success(data.text);

            container.updateCartIndexView(data);
        })
    }

    initEvents() {
        this.addEventListener('click',  (e) => {
            e.preventDefault();

            this.removeCodePromo(this.mainContainer,e.target.closest("#remove-promo"));
        });
    }
};

